import { Link, Meta, Title } from '@solidjs/meta';
import { useLocation } from '@solidjs/router';
import { useVenue } from 'Shared/VenueProvider';
import { title } from 'Shared/frontend/Title';
import { useSite, useUrls } from 'Shared/SiteProvider';
import { createMemo, For, Show } from 'solid-js';
import { useSettings } from 'Shared/frontend/SettingsProvider';
import { Dynamic } from 'solid-js/web';


export function PageMeta(P)
{
	const venue = useVenue();

	const photo = venue.photo;
	const imageUrl = createMemo(() => {
		if (!photo) return undefined;

		return {
			...photo.formats.medium,
			url: useUrls().imageUrl('Venue-photo',photo?.hash,'medium','jpeg',!photo?.dev,true)
		};
	});

	const url = useSite().hostUrl + useLocation().pathname;
	const tit = () => title(venue,P.title);

	return (<>
		<Title>{tit()}</Title>
		<Link rel='canonical' href={url} />

		<Meta property='og:type' content='website' />
		<Meta property='og:url' content={url} />
		<Meta property='og:site_name' content={venue.nickname ?? venue.name} />
		<Meta property='og:title' content={tit()} />

		<Show when={imageUrl()}>
			<OgImage {...imageUrl()} />
		</Show>

		<GoogleInfo extra={P} image={imageUrl()} />

		<For each={useSettings().fontIncludes()}>{component =>
			<Dynamic component={component} />
		}</For>
	</>);
}


//FIXME or use Image or ImageDetails or a new type? SEE: StandardHeadInsert. May be a bug... cf format vs formats
export function OgImage(P)
{
	return (<>
		<Meta property='og:image' content={P.url} />

		<Show when={P.format}>
			<Meta property='og:image:type' content={P.format} />
		</Show>
		<Show when={P.width}>
			<Meta property='og:image:width' content={P.width} />
		</Show>
		<Show when={P.height}>
			<Meta property='og:image:height' content={P.height} />
		</Show>
	</>);
}


export function GoogleInfo(P)
{
	const venue = useVenue();

	const details = () => {
		 /* 
			Google recommends a width of 1920px wide (seriously?), with a min width 720px, and for
			"best" results a supplying images in 16x9, 4x3, and 1x1. Great.
		*/
		let data:any = { '@context': 'https://schema.org' };

//		"@type": "Event",   XXX Whats a good default? Needs to be overridable if supplied...

		if (P.image)
			data = {...data, image: [ P.image?.url ]};

		data = {
			...data,

			location: {
				'@type': 'Place',
				name: venue.name,
				address: {
					'@type': 'PostalAddress',
					streetAddress: venue.streetAddress,
					addressLocality: venue.suburb,
					postalCode: venue.postcode,
					addressRegion: venue.state,
					addressCountry: venue.country
				}
			}
		};

		if (P.extra)
			data.extra = P.extra;

		return data;
	};

	/* This will find its way into the body. According to Google this is OK. */
	return (
		<script type='application/ld+json'>
			{JSON.stringify(details())}
		</script>
	);
}

